import { SharePanelAction, SharePanelActionKeys } from './actions';
import { Api } from '../../typings/api';
import Utils from '../../utils';
import { PopupTheme } from '../../components/Popup';
import { CallbackAction } from '../DriveItemList/actions';

enum FormType {
	Uprez = 'uprezForm',
	Webpublication = 'webpublicationForm'
}

enum CopyMode {
	html = 'html',
	text = 'text'
}

interface FormState {
	company: string;
	contactEmail: string;
	userName: string;
	firstname: string;
	message: string;
	userEmail: string;
	subject: string;
	phone: string;
	position: string;
	surname: string;
	createDeal: boolean;
}

interface SelectedNote {
	id: number;
	title: string;
}

interface SharePanelState {
	isOpen: boolean;
	isShareActionsPopupOpen: boolean;
	isShareViaCopyPopupOpen: boolean;
	theme?: PopupTheme;
	copyMode: CopyMode;
	shareViaCopyData: ShareViaCopyResource[];
	pin: string;
	isProcessing: boolean;
	selectedResources: Api.DriveItem[];
	selectedNotes: SelectedNote[];
	foldersContent: Api.DriveItem[];
	form: FormState;
	isPublicationShare: boolean;
	crmContacts: Api.CrmContact[];
	callbackAction?: CallbackAction;
}

export interface ShareViaCopyResource {
	url: string;
	label: string;
}

const initialFormState = {
	company: '',
	firstname: '',
	subject: '',
	phone: '',
	position: '',
	surname: '',
	contactEmail: '',
	message: '',
	userEmail: '',
	userName: '',
	createDeal: false,
};

const initialState: SharePanelState = {
	isOpen: false,
	isShareActionsPopupOpen: false,
	isShareViaCopyPopupOpen: false,
	copyMode: CopyMode.text,
	shareViaCopyData: [],
	pin: '',
	isProcessing: false,
	selectedResources: [],
	selectedNotes: [],
	foldersContent: [],
	form: initialFormState,
	isPublicationShare: false,
	crmContacts: [],
	callbackAction: undefined,
};

function sharePanel(
	state: SharePanelState = initialState,
	action: SharePanelAction
): SharePanelState {
	let newState = Utils.deepCopy(state);
	switch (action.type) {
		case SharePanelActionKeys.OPEN_PANEL:
			newState.isOpen = true;
			newState.isPublicationShare = action.isPublicationShare;
			newState.callbackAction = action.callbackAction;
			return newState;
		case SharePanelActionKeys.CLOSE_PANEL:
			newState.isOpen = false;
			newState.isPublicationShare = false;
			newState.foldersContent = [];
			return newState;
		case SharePanelActionKeys.OPEN_SHARE_ACTIONS_POPUP:
			newState.isShareActionsPopupOpen = true;
			newState.isPublicationShare = action.isPublicationShare;
			newState.selectedResources = action.sharedItems;
			newState.callbackAction = action.callbackAction;
			return newState;
		case SharePanelActionKeys.CLOSE_SHARE_ACTIONS_POPUP:
			newState.isShareActionsPopupOpen = false;
			newState.isPublicationShare = false;
			if (action.shouldResetSelection) {
				newState.selectedResources = [];
				newState.selectedNotes = [];
				newState.callbackAction = undefined;
			}
			return newState;
		case SharePanelActionKeys.OPEN_SHARE_VIA_COPY_POPUP:
			newState.isShareViaCopyPopupOpen = true;
			newState.shareViaCopyData = action.shareViaCopyData;
			newState.pin = action.pin;
			newState.theme = action.theme;
			newState.callbackAction = action.callbackAction;
			return newState;
		case SharePanelActionKeys.CLOSE_SHARE_VIA_COPY_POPUP:
			newState.isShareViaCopyPopupOpen = false;
			newState.shareViaCopyData = [];
			newState.pin = '';
			newState.theme = undefined;
			newState.callbackAction = undefined;
			return newState;
		case SharePanelActionKeys.SET_COPY_MODE:
			newState.copyMode = action.copyMode;
			return newState;
		case SharePanelActionKeys.START_PROCESSING:
			newState.isProcessing = true;
			return newState;
		case SharePanelActionKeys.FINISH_PROCESSING:
			newState.isProcessing = false;
			return newState;
		case SharePanelActionKeys.RESET_FORM:
			newState.form = initialFormState;
			newState.selectedResources = [];
			newState.selectedNotes = [];
			return newState;
		case SharePanelActionKeys.SET_SELECTION: {
			if (action.selectedResources) {
				newState.selectedResources = action.selectedResources;
			}
			if (action.selectedNotes) {
				newState.selectedNotes = action.selectedNotes;
			}
			return newState;
		}
		case SharePanelActionKeys.SET_FORM_FIELD:
			newState.form[action.name] = action.value;
			return newState;
		case SharePanelActionKeys.UPDATE_FOLDERS_CONTENT:
			newState.foldersContent = [...state.foldersContent, action.item];
			return newState;
		case SharePanelActionKeys.SET_CRM_CONTACTS:
			newState.crmContacts = action.crmContacts;
			return newState;
		default:
			return state;
	}
}

export { SharePanelState, FormState, FormType, CopyMode, SelectedNote, sharePanel };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Share/reducer.ts